"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryConnectingAttributesService = void 0;
var tslib_1 = require("tslib");
var sdk_model_1 = require("@gooddata/sdk-model");
var effects_1 = require("redux-saga/effects");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var store_1 = require("../store");
var queryService_1 = require("../store/_infra/queryService");
var general_1 = require("../events/general");
exports.QueryConnectingAttributesService = queryService_1.createCachedQueryService("GDC.DASH/QUERY.CONNECTING.ATTRIBUTES", queryService, function (query) {
    var refs = query.payload.refs;
    var serializedRefs = refs.flatMap(function (refs) { return refs; }).map(sdk_model_1.serializeObjRef);
    return serializedRefs.join("&");
});
function loadConnectingAttributes(ctx, attributeRefs) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var backend, workspace;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    backend = ctx.backend, workspace = ctx.workspace;
                    return [4 /*yield*/, backend.workspace(workspace).attributes().getCommonAttributesBatch(attributeRefs)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
function loadConnectingAttributesMeta(ctx, connectingAttributeRefs) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var backend, workspace, attributeMetaObjects;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    backend = ctx.backend, workspace = ctx.workspace;
                    return [4 /*yield*/, Promise.all(connectingAttributeRefs.map(function (refsEntry) {
                            return Promise.all(refsEntry.map(function (ref) { return backend.workspace(workspace).attributes().getAttribute(ref); }));
                        }))];
                case 1:
                    attributeMetaObjects = _a.sent();
                    return [2 /*return*/, attributeMetaObjects.map(function (entry) {
                            return entry.map(function (attributeMeta) {
                                return {
                                    title: attributeMeta.title,
                                    ref: attributeMeta.ref,
                                };
                            });
                        })];
            }
        });
    });
}
function mapDisplayFormsToAttributes(refs) {
    var attributeDisplayFormsMap;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(store_1.selectAttributeFilterDisplayFormsMap)];
            case 1:
                attributeDisplayFormsMap = _a.sent();
                return [2 /*return*/, refs.map(function (displayFormRefsEntry) {
                        return displayFormRefsEntry.map(function (displayFormRef) { var _a; return (_a = attributeDisplayFormsMap.get(displayFormRef)) === null || _a === void 0 ? void 0 : _a.attribute; });
                    })];
        }
    });
}
function queryService(ctx, query) {
    var refs, correlationId, attributeRefs, nonEmptyAttributesRef, connectingAttributesRefs, connectingAttributes;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                refs = query.payload.refs, correlationId = query.correlationId;
                return [4 /*yield*/, effects_1.call(mapDisplayFormsToAttributes, refs)];
            case 1:
                attributeRefs = _a.sent();
                nonEmptyAttributesRef = compact_1.default(attributeRefs.map(function (refsEntry) { return compact_1.default(refsEntry); }));
                if (refs.length !== nonEmptyAttributesRef.length) {
                    throw general_1.invalidQueryArguments(ctx, "Cannot find attributes for given displayForms", correlationId);
                }
                return [4 /*yield*/, effects_1.call(loadConnectingAttributes, ctx, nonEmptyAttributesRef)];
            case 2:
                connectingAttributesRefs = _a.sent();
                return [4 /*yield*/, effects_1.call(loadConnectingAttributesMeta, ctx, connectingAttributesRefs)];
            case 3:
                connectingAttributes = _a.sent();
                return [2 /*return*/, connectingAttributes];
        }
    });
}
//# sourceMappingURL=queryConnectingAttributes.js.map